import React from 'react';
import { CapacityConfidence } from '../../../../../types/consolidation';

interface FillMeterProps {
    /** Fyllgrad i prosent (0-100+). Verdier over 100 vises som full rød måler. */
    pct: number;
}

/**
 * Liten fyllgrad-måler for mål-lokasjoner. Grønn opp til 75 %,
 * gul opp til 95 %, rød over.
 */
export const FillMeter: React.FC<FillMeterProps> = ({ pct }) => {
    const clamped = Math.max(0, Math.min(100, pct));
    const barColor = pct <= 75 ? 'bg-green-500' : pct <= 95 ? 'bg-yellow-500' : 'bg-red-500';

    return (
        <div className="flex items-center gap-2 flex-1 min-w-0">
            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                    className={`h-full rounded-full ${barColor}`}
                    style={{ width: `${clamped}%` }}
                />
            </div>
            <span className="text-xs text-gray-600 whitespace-nowrap">{Math.round(pct)}%</span>
        </div>
    );
};

interface CapacityConfidenceBadgeProps {
    confidence: CapacityConfidence;
    /** Tekst for 'estimated' (f.eks. «ca.» eller «ca. kapasitet»). */
    approxText: string;
    /** Tekst for 'unknown' (f.eks. «ukjent — bekreft manuelt»). */
    unknownText: string;
}

/**
 * Gult merke for usikker kapasitet. 'observed' gir ingen badge.
 * Tekstene sendes inn av kalleren slik at i18n-nøklene blir i riktig gruppe.
 */
export const CapacityConfidenceBadge: React.FC<CapacityConfidenceBadgeProps> = ({
    confidence,
    approxText,
    unknownText
}) => {
    if (confidence === 'observed') return null;

    return (
        <span className="inline-flex items-center px-2 py-0.5 bg-yellow-100 text-yellow-800 text-xs rounded-full whitespace-nowrap">
            {confidence === 'estimated' ? approxText : unknownText}
        </span>
    );
};
